// extracted by mini-css-extract-plugin
module.exports = {"chartSection":"ApplicationTokenCharts_chartSection__FcPyG","chart":"ApplicationTokenCharts_chart__jgRWD"};